import React from 'react';
import BenefitItem from './BenefitItem';
import styles from '../../../components/styles/companyvision.module.css';

const BenefitsCard = () => {
  return (
    <div className={styles["benefits-card"]}>
      <BenefitItem 
        icon="🏆"
        title="顧客満足度95%"
        description="当社内部の期待を超えて95％の顧客から満足との評価をいただき、優れたITソリューションと献身的サポート力が実証されています。"
        />
      
      <BenefitItem 
        icon="💰"
        title="業界で12年以上の経験"
        description="12 年以上の経験を持つ DG FutureTech は、専門的な IT ソリューションを保証し、テクノロジーの複雑さを乗り越えてお客様のビジネスを導きます。"
        />

<BenefitItem 
        icon="☁️"
        title="24時間365日サポート"
        description="当社では、ダウンタイムを最小限に抑えながら、 ITシステムがスムーズに稼働し続けるよう、24時間365日のサポートを提供しています。"
        />
      <BenefitItem 
        icon="🔒"
        title="ISO 27001:2022認証取得"
        description="        お客様のデータのセキュリティは弊社の最優先事項です。ISO 27001:2022 認証を取得しており、堅牢なセキュリティ対策で最高レベルの保護を保証します。"
        />
    </div>
  );
};

export default BenefitsCard;